export const PRINT_PLAN_QUEUE_COLUMN_WIDTH = 1121
